/* eslint-disable react/sort-comp */
/* eslint-disable object-curly-newline */

import React, { Component } from 'react';

import AddEditNewModal from 'stocks/components/common/AddEditNewModal';
import DeleteModal from 'stocks/components/common/DeleteModal';
import Item from 'stocks/components/common/Item';

class BrandItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newCategory: '',
      newEditableCategory: '',
      editCategoryModal: false,
      openAddNewCategoryModal: false,
      deleteModalCategory: false,
      disabledSaveCategory: true,
      brand: [
        {
          id: 1,
          name: 'Kerastase',
          numberOfProducts: '46',
        },
        {
          id: 2,
          name: 'L’Oréal Professionnel',
          numberOfProducts: '234',
        },
        {
          id: 3,
          name: 'Redken',
          numberOfProducts: '2',
        },
        {
          id: 4,
          name: 'L’Oreal Professional',
          numberOfProducts: '69',
        },
      ],
    };
  }

  openAddNewModal = () => {
    this.setState({ openAddNewCategoryModal: true });
  };
  closeAddNewModal = () => {
    this.setState({ openAddNewCategoryModal: false });
  };
  saveNewCategory = () => {};
  onDeleteCategory = () => {
    this.setState({ deleteModalCategory: true });
  };
  changeInputCategory = () => {};
  disabledSaveCategory = () => {};
  onEditCategory = () => {
    this.setState({ editCategoryModal: true });
  };
  closeEditCategoryModal = () => {
    this.setState({ editCategoryModal: false });
  };
  saveEditCategory = () => {};
  changeInputCategoryEdit = () => {};
  newEditableCategory = () => {};
  deleteCategory = () => {};
  closeModal = () => {
    this.setState({ deleteModalCategory: false });
  };

  render() {
    // if (isFetching) {
    //   return (
    //     <div className="lds-wrap">
    //       <div className="lds-ring">
    //         <div />
    //         <div />
    //         <div />
    //         <div />
    //       </div>
    //     </div>
    //   );
    // } else if (brand) {
    return (
      <div className="warp-container">
        <div className="items-header">
          <div>{this.props.title}</div>
          <span>Products assigned</span>
          <div className="btn-add-new">
            <button className="btn btn-violet" id="add-new-brand" onClick={this.openAddNewModal}>
              Add new
            </button>
          </div>
        </div>

        <ul className="item-list">
          {this.state.brand.map((b) => (
            <Item
              key={b.id}
              id={b.id}
              name={b.name}
              numberOfProducts={b.numberOfProducts}
              editBtnText="Edit"
              deleteBtnText="Delete"
              onEdit={this.onEditCategory}
              onDelete={this.onDeleteCategory}
            />
          ))}
        </ul>
        {this.state.openAddNewCategoryModal && (
          <AddEditNewModal
            modalTitle="Add new brand"
            label="Brand name"
            onCancel={this.closeAddNewModal}
            onSave={this.saveNewCategory}
            changeInput={this.changeInputCategory}
            inputVal={this.state.newCategory}
            disabledSave={this.state.disabledSaveCategory}
          />
        )}
        {this.state.editCategoryModal && (
          <AddEditNewModal
            modalTitle="Edit brand"
            label="Brand name"
            onCancel={this.closeEditCategoryModal}
            onSave={this.saveEditCategory}
            changeInput={this.changeInputCategoryEdit}
            inputVal={this.state.newEditableCategory}
            disabledSave={this.state.disabledSaveCategory}
          />
        )}
        {this.state.deleteModalCategory && (
          <DeleteModal
            modalTitle="Delete brand"
            text1="Any products in this category will be reassigned to the
            category Unknown. You can assign a new category in Stock Manager."
            text2="Are you sure you want to delete?"
            onCancel={this.closeModal}
            onDelete={this.deleteCategory}
          />
        )}
      </div>
    );
    // }
  }
}

export default BrandItems;
